export type SpCampaignState = 'ENABLED' | 'PAUSED';
export type SpTargetingType = 'AUTO' | 'MANUAL';
export type SpManualTargetingKind = 'KEYWORD' | 'PRODUCT';
export type SpBiddingStrategy = 'LEGACY_FOR_SALES' | 'AUTO_FOR_SALES' | 'MANUAL';
export type SpMatchType = 'EXACT' | 'PHRASE' | 'BROAD';
export type SpNegativeMatchType = 'NEGATIVE_EXACT' | 'NEGATIVE_PHRASE';
export type SpProductTargetMatch = 'EXACT' | 'EXPANDED';

export type SpAdvertisedProduct = {
  asin: string;
  sku?: string;
  title?: string;
  imageUrl?: string;
  eligibilityStatus?: string;
  price?: number;
  availability?: string;
  rating?: number;
};

export type SpAddedKeyword = {
  keywordText: string;
  matchType: SpMatchType;
  suggestedBid: number | null;
  suggestedBidMin?: number | null;
  suggestedBidMax?: number | null;
  bid: string;
};

export type SpAddedProductTarget = {
  id: string;
  kind: 'CATEGORY' | 'PRODUCT';
  expressionType: 'ASIN_CATEGORY_SAME_AS' | 'ASIN_SAME_AS' | 'ASIN_EXPANDED_FROM';
  value: string;
  label: string;
  path?: string;
  imageUrl?: string;
  suggestedBid: number | null;
  bid: string;
};

export type SpAddedNegativeKeyword = {
  keywordText: string;
  matchType: SpNegativeMatchType;
};

export type SpAddedNegativeProduct = {
  asin: string;
};

export type SpAddedNegativeBrand = {
  brand: string;
};

export type SpKeywordSuggestionRow = {
  keywordText: string;
  matchType: SpMatchType;
  suggestedBid: number | null;
  suggestedBidMin?: number | null;
  suggestedBidMax?: number | null;
};

export type SpCategorySuggestion = {
  id: string;
  name: string;
  path: string;
  canBeTargeted: boolean;
  suggestedBid: number | null;
  bidMin: number | null;
  bidMax: number | null;
  productCountLabel?: string;
};

export const SP_BIDDING_STRATEGIES: Array<{
  value: SpBiddingStrategy;
  label: string;
  description: string;
}> = [
  {
    value: 'LEGACY_FOR_SALES',
    label: 'Dynamic bids – up and down',
    description:
      "We'll raise your bids (by a maximum of 100% on all placements) in real time when your ad may be more likely to convert to a sale, and lower your bids when less likely to convert to a sale.",
  },
  {
    value: 'AUTO_FOR_SALES',
    label: 'Dynamic bids – down only',
    description: "We'll lower your bids in real time when your ad may be less likely to convert to a sale.",
  },
  {
    value: 'MANUAL',
    label: 'Fixed bids',
    description:
      "We'll use your exact bid and any manual adjustments you set, and won't change your bids based on likelihood of a sale.",
  },
];
